import angular from 'angular';

// see documentation on od-properties-navigation-container
module.exports = angular.module('common.components.od-properties-navigation-node', [
])
.component('odPropertiesNavigationNode', {
  transclude: true,
  template: '<div ng-transclude />',
  require: {
    parentNode: '?^^odPropertiesNavigationNode'
  },
  bindings: {
    onSetVisibility: '&',
    parentRefs: '=refs',
  },
  controller: class {
    // make parent menu layer aware of this menu layer
    $onInit() {
      if (this.parentNode) {
        this.parentRefs.parentNode = this.parentNode;
        this.parentNode.setChildNode(this);
      }

      this.parentRefs.node = this;
    }

    // this happens when all the children menu components have been inserted into the DOM,
    // so if this is the leaf menu layer, it should show itself
    $postLink() {
      if (!this.childNode) {
        this.onSetVisibility({
          isVisible: true,
        });
      }
    }

    setChildNode(childNode) {
      this.parentRefs.childNode = this.childNode = childNode;
      this.onSetVisibility({
        isVisible: false,
      });
    }

    goUpOneLevel() {
      this.onSetVisibility({
        isVisible: false,
      });
      this.parentNode.onSetVisibility({
        isVisible: true,
      });
    }

    // if we go to an active link, it may be the current leaf or a parent of the current leaf
    goToActive() {
      // go down one level unless we're at the current leaf
      if (!this.childNode) {
        return;
      }

      this.onSetVisibility({
        isVisible: false,
      });
      this.childNode.onSetVisibility({
        isVisible: true,
      });
    }
  },
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/od-properties-navigation-node.js
 **/